import { createContext } from 'react';

export const AccountingWebSocketContext = createContext({
  dispatchMessage: () => {},
  registerHandler: () => {},
  unregisterHandler: () => {},
});
